module.exports = __webpack_public_path__ + "static/media/r30.f00d22f5.jpg";